
export const SpecialBookingType = {
    Birthday: 1
}